import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.querySelectorAll('.highlighted_categories')?.forEach((element) => {
    const paginationEl = element.parentElement.querySelector(
        '.highlighted_categories-pagination-container',
    );
    const nextEl = element.parentElement.querySelector('.highlighted_categories-navigation-right');
    const prevEl = element.parentElement.querySelector('.highlighted_categories-navigation-left');

    return new Swiper(element, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        breakpoints: {
            768: {
                slidesPerView: '3',
            },
            1024: {
                slidesPerView: '4',
            },
        },
        spaceBetween: 16,
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: (index, className) => {
                return `<span class="${className}"></span>`;
            },
        },
        navigation: {
            nextEl,
            prevEl,
        },
    });
});
